export default __webpack_public_path__ + "static/media/supplement.40c5426b.png";